import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

export class CompanyServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 筛查
  public getCompanySelectList(opts: object) {
    const url = serverUrl + '/api/yunnan/company/select';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
}
